export const MEDIA = {
    NO_RESULTS_MESSAGE: "no-results-message",
    TABS: {
        MANAGE_MEDIA: "manage-media",
        MANAGE_UNLINKED_MEDIA: "manage-unlinked-media",
    },
    MANAGE_MEDIA_TABLE: {
        DRAG_HANDLE: "drag-media-handle",
        IMAGE_3D_ICON: "image-3d-icon",
        MEDIA_SOURCE_CONTAINER: "media-source-container",
        MEDIA_IMAGE_PLACEHOLDER: "media-image-placeholder",
        MEDIA_IMAGE: "media-image",
        MEDIA_TYPE: "media-type",
        MEDIA_POSITION: "media-position",
        ACTIONS: {
            MOVE_UP: "move-media-up",
            MOVE_DOWN: "move-media-down",
            MOVE_TOP: "move-media-top",
            MOVE_BOTTOM: "move-media-bottom",
            DELETE: "delete-media",
        },
    },
    UNLINKED: {
        TABLE_ROOT: "unlinked-media-table-root",
        TAB_TITLE: "unlinked-media-tab-title",
        ADD_CHECKBOX: "add_checkbox",
        UNLINKED_MEDIA_SOURCE_CONTAINER: "unlinked-media-source-container",
        ADD_BUTTON: "unlinked-media-add",
        SEARCH: "unlinked-media-search",
        FILE_NAME: "unlinked-media-filename",
        SHOW_ALL: "show-all",
        ZOOM: "zoom",
    },
};
